import type { FC } from 'react';
import { SuspenseBoundary } from '../../../../../../components/utility/SuspenseBoundary';
import { NetSuiteSyncWizardContent, NetSuiteSyncWizardDialogLoading } from './components';
import type { NetSuiteSyncWizardProps } from './types';

export const NetSuiteSyncWizard: FC<NetSuiteSyncWizardProps> = (props) => {
  return (
    <SuspenseBoundary
      suspenseProps={{
        fallback: <NetSuiteSyncWizardDialogLoading open={props.open} onClose={props.onClose} />,
      }}
    >
      <NetSuiteSyncWizardContent {...props} />
    </SuspenseBoundary>
  );
};
